import { useIsDesktopDevice } from "./useIsDesktopDevice.ts";

const useIsMobileDevice = () => {
  return !useIsDesktopDevice();
};

export { useIsMobileDevice };
